<template>
  <section class="v-select">
    <section>
      <el-autocomplete
        v-model="selectValue"
        class="inline-input"
        :fetch-suggestions="querySearch"
        :value-key="valueKey"
        :type="type"
        :maxlength="maxlength"
        :minlength="minlength"
        :disabled="disabled"
        @select="handleSelect"
        @focus="handleFocus"
        @change="handlerChange"
        @blur="handlerBlur"
      >
        <template slot-scope="{ item }">
          <slot :item="item" />
        </template>
        <template
          v-if="append"
          slot="append"

        >
          <span
            class="hand"
          >
            {{ append }}
          </span>

        </template>
      </el-autocomplete>
    </section>

  </section>

</template>

<script>
export default {
  name: 'VInputSelect',
  props: {
    value: {
      type: [Number,String],
      default: ''
    },
    remoteMethod:{
      type:Function
    },
    list: {
      type: Array,
      default: () => ([])
    },
    append: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    filterable: {
      type: Boolean,
      default: true
    },
    remote: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    // vant
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    blue: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    borderBottom: {
      type: Boolean,
      default: false
    },
    borderBottomBlue: {
      type: Boolean,
      default: false
    },
    defaultOption:{
      type: Boolean,
      default: true
    },
    // 是否显示第一个默认的值
    isShowFirstValue: {
      type: Boolean,
      default: true,
    },
    canSelect:{
      type: Boolean,
      default: false
    },
    keyNumber: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [String, Number],
      default: ''
    },
    minlength: {
      type: [String, Number],
      default: ''
    },
    max: {
      type: [Number, Object],
      default: null
    },
    min: {
      type: [Number, Object],
      default: null
    },
  },
  data() {
    return {
      selectValue: '',
      // vant
      text: '',
      //   selectValue: '',
      selectLabel: '',
      show: false,
      options:this.list,
      timeout:  null
    }
  },
  computed: {
    columns() {
      if(this.list && this.list.length > 0) {
        return this.list.reduce((result, item) => {
          result.push(item[this.labelKey])
          return result
        }, [])
      }
      return []
    },
    isNumber() {
      if(!(this.list instanceof Array) || this.list.length == 0 ) {
        return false
      }
      let id = this.list[0][this.valueKey]
      return typeof id === 'number'? true: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val, old) {
        if(val === '') {
          this.selectValue = ''
          this.selectLabel = ''
        }
        else {
          let currentValue = val
          if(this.type=='number'&&this.maxlength){
            currentValue = currentValue.length>this.maxlength?currentValue.slice(0,this.maxlength):currentValue
          }
          if(typeof this.min == 'number' && Number(currentValue) < this.min) {
            currentValue = this.min
          }
          if(typeof this.max == 'number' && Number(currentValue) > this.max) {
            currentValue = this.max
          }
          this.selectValue = currentValue
        }
        // if (val !== this.selectValue ) {
        //   this.handleValue(val)
        // }
      }
    },
    list: {
      deep: true,
      immediate:true,
      handler(val) {
        this.options= val
        if(val && val.length > 0) {
          // this.handleValue(this.selectValue)
        }
      }
    },
    selectValue(val) {
      const result = this.list
      let currentValue = val
      if(this.keyNumber) {
        const pat = /[0-9]/g
        const patResult = currentValue.toString().match(pat)
        currentValue = patResult? patResult.join(''): ''
      }
      if(result && this.selectLabel !== result[this.labelKey]) {
        this.selectLabel = result[this.labelKey]
      }
      this.$emit('input', currentValue)
    }
  },
  created() {
    // // 设置默认选中第一个值
    // if (this.isShowFirstValue && this.list.length>0) {
    //   this.currentValue = this.list[0][this.valueKey]
    //   this.$emit('input', this.list[0][this.valueKey])
    // }
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.list||[]
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (list) => {
        // if(list.length<=0) return
        if(this.canSelect){
          return list[this.valueKey].toString().indexOf(queryString.toString()) === 0
        }
        return list
      }
    },
    handleSelect(item) {
      this.selectValue = item[this.valueKey]
      setTimeout(()=>{
        this.handlerChange()
      },200)
    },
    handlerChange(){
      this.$emit('input', this.selectValue)
      this.$emit('change', this.selectValue)
    },
    handlerBlur(){
      this.$emit('input', this.selectValue)
      this.$emit('blur', this.selectValue)
    },
    handleFocus(){
      this.$emit('focus')
    },
    getOptionData(val) {
      let result = {}
      this.list.some(item => {
        if (item[this.valueKey] == val) {
          result = item
          return true
        }
        return false
      })
      return result
    },

    onCancel() {
      this.show = false
    },
    onConfirm(item, index) {
      this.selectValue = this.list[index][this.valueKey]
      this.selectLabel = item
      this.$emit('input', this.selectValue)
      this.$emit('change', this.selectValue)
      this.show = false
    },
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
}
.v-select {
  .v-input {
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
.el-select-dropdown__item {
  height: auto;
  line-height: auto;
  .send-info {
    padding-bottom: 5px;
    span {
      display: block;
      line-height: 15px;
      font-size: 12px;
    }
  }
}
::v-deep .show-element{
  ::v-deep .el-autocomplete{
    width: 100%;
    height: 32px;
    line-height: 32px;
  }
}
</style>
